<template>
  <div v-if="showCard">
    <div v-if="isSafari" class="ios g-content c-theme-reverse br-lg">
      <div class="p-r">
        <p class="c-theme p-content pb-16" style="line-height: 32px;">
          <t class="mr-4" path="home_61">To open WeTrade from Home screen First Tap</t>
          <Pic src="home/add_ios_1" width="32" height="32" />
          <t class="mx-8" path="home_62">then</t>
          <Pic src="home/add_ios_2" width="152" height="32" />
        </p>
        <Button class="btn block primary br-lg mt-16" @click="handleClose">
          <t path="placeorder_50"></t>
        </Button>
        <span class="arow"></span>
      </div>
    </div>
    <div v-if="isChrome" class="chrome g-content c-theme-reverse br-lg">
      <div class="p-r">
        <p class="c-theme p-content pb-16" style="line-height: 32px;">
          <t class="mr-4" path="home_61">To open WeTrade from Home screen First Tap</t>
          <Pic src="home/add_chrome_1" width="32" height="32" />
          <t class="mx-8" path="home_62">then</t>
          <Pic src="home/add_chrome_2" width="152" height="32" />
        </p>
        <Button class="btn block primary br-lg mt-16" @click="handleClose">
          <t path="placeorder_50"></t>
        </Button>
        <span class="arow"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, shallowRef, watch } from 'vue'
import Pic from '@/components/Pic.vue'
import { localGet, localSet } from 'essential/store/localStore'
import { keymap } from '@/config'
import Button from '@/components/Button.vue'

export default defineComponent({
  name: 'TheAddToDesk',
  components: {
    Pic,
    Button,
  },
  props: {
    show: Boolean,
  },
  setup (props) {
    const showCard = shallowRef(false)

    var userAgent = navigator.userAgent
    const isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1 // 判断是否Safari浏览器
    const isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 // 判断Chrome浏览器

    watch(() => props.show, () => {
      if (props.show) {
        const haveShow = localGet(keymap.label.showCollect)
        if (!haveShow) {
          showCard.value = true
        }
      }
    })

    const handleClose = () => {
      localSet(keymap.label.showCollect, '1')
      showCard.value = false
    }
    return {
      showCard,
      isSafari,
      isChrome,
      handleClose,
    }
  },
})
</script>

<style scope lang="scss">
.g-content{
  width: calc(100vw - 16px);
  margin: 0 8px;
  background: var(--color-theme-reverse);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.5);
  opacity: 0.94;
  padding: 16px 24px;
  .p-content{
    border-bottom: 1px solid var(--color-theme);
  }
}
.ios{
  position: fixed;
  bottom: 80px;
  .arow{
    position: absolute;
    bottom: -24px;
    left: 50%;
    margin-left: -4px;
    width: 0;
    height: 0;
    border-top: 8px solid var(--color-theme-reverse);
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
  }
}
.chrome{
  position: fixed;
  top: 16px;
  .arow{
    position: absolute;
    top: -24px;
    right: 0;
    width: 0;
    height: 0;
    border-bottom: 8px solid var(--color-theme-reverse);
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
  }
}
</style>
